var map = {
	"./arrow-back.svg": "b8a8",
	"./arrow-bottom.svg": "ae00",
	"./arrow.svg": "21e2",
	"./avatar.svg": "f2e9",
	"./bb-destiny.svg": "23ea",
	"./bb-person.svg": "3115",
	"./bb-travel-calendar.svg": "8c5e",
	"./calendar.svg": "b8bd",
	"./check-confirmation.svg": "be30",
	"./check-error.svg": "5754",
	"./check-off.svg": "5b15",
	"./check-on.svg": "6585",
	"./check-success.svg": "f955",
	"./check.svg": "7bae",
	"./chevron-up.svg": "bb5d",
	"./circles.svg": "da05",
	"./close.svg": "8b1b",
	"./copy.svg": "8aac",
	"./covid-protection-shield.svg": "5515",
	"./cupom.svg": "1f36",
	"./destiny.svg": "fab1",
	"./driver.svg": "345c",
	"./edit-white.svg": "6be9",
	"./edit.svg": "daf0",
	"./icon-calendar-purple.svg": "65df",
	"./icon-check.svg": "dc7b",
	"./icon-chevron-left.svg": "a30b",
	"./icon-coverage-purple.svg": "886f",
	"./icon-livelo-purple.svg": "4f27",
	"./icon-location-purple.svg": "6ff2",
	"./icon-passengers-purple.svg": "e924",
	"./icon-person.svg": "5d28",
	"./icon-persons.svg": "5886",
	"./icon-pix-purple.svg": "5401",
	"./icon-success-purple.svg": "d437",
	"./icon-up.svg": "0cf9",
	"./icon-warning.svg": "1575",
	"./icons-success.svg": "0edf",
	"./internet.svg": "78cd",
	"./liveloPoints.svg": "bf8a",
	"./loader-dark.svg": "488e",
	"./loader.svg": "04ff",
	"./ok.svg": "fecb",
	"./passengerPerson.svg": "5fc1",
	"./person.svg": "d104",
	"./pet-medicine.svg": "462c",
	"./plus.svg": "eb38",
	"./product-pension.svg": "66e8",
	"./protected-cellphone.svg": "cba7",
	"./roof.svg": "80d5",
	"./sim-card.svg": "a6f5",
	"./smile-bad.svg": "60f1",
	"./smile-good.svg": "8581",
	"./smile-neutral.svg": "ca23",
	"./telefone.svg": "9460",
	"./travel-calendar.svg": "123d",
	"./voucher.svg": "295f",
	"./wallter.svg": "4c12",
	"./watch.svg": "bacc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";